import SpellTrio from '../interface/SpellTrio'

const fromDefault = (): SpellTrio => {
  return {} as SpellTrio
}

export default {
  fromDefault
}
